import React from 'react';
import {twMerge} from 'tailwind-merge';

const ContentWrapper = (props) => {
    const {className, children, testId, lang, ariaHidden} = props;

    return (
        <div
            aria-hidden={ariaHidden}
            className={twMerge(
                'mx-8 my-0 flex flex-col items-center sm:mx-9 md:mx-12 lg:mx-14 xl:mx-auto xl:max-w-[1480px]',
                className
            )}
            data-testid={testId}
            lang={lang}
        >
            {children}
        </div>
    );
};

export default ContentWrapper;
